'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('org/product/detail'));
    processInclude(require('wishlists/product/wishlist'));
    processInclude(require('./content/lazyload'));
    processInclude(require('adyen/adyen/express/product/expressPayments'));
});
